var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.posts),function(post,i){return _c('div',{key:i,staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('post-card',{attrs:{"post":post}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }